import { USER_SIGNUP_ERROR_TYPES } from 'connect/constants';

export const PRETTY_SIGNUP_ERROR_MESSAGES: Record<
  typeof USER_SIGNUP_ERROR_TYPES[keyof typeof USER_SIGNUP_ERROR_TYPES],
  string
> = {
  [USER_SIGNUP_ERROR_TYPES.LOGGED_IN_AS_NOT_PATIENT]: 'You are already logged in and not a patient',
  [USER_SIGNUP_ERROR_TYPES.EMAIL_INVALID]: 'Invalid email address',
  [USER_SIGNUP_ERROR_TYPES.PHONE_INVALID]: 'Invalid phone number',
  [USER_SIGNUP_ERROR_TYPES.EMAIL_ALREADY_REGISTERED]: 'A user with this email already exists. Try logging in.',
  [USER_SIGNUP_ERROR_TYPES.PHONE_ALREADY_REGISTERED]: 'A user with this phone number already exists. Try another number or contact support@opencare.com',
  [USER_SIGNUP_ERROR_TYPES.EMAIL_ASSOCIATED_WITH_PRACTICE_USER]: 'This email cannot be used to complete a booking.',
  [USER_SIGNUP_ERROR_TYPES.GENERIC]: 'An unknown error occurred',
};
